import { render, staticRenderFns } from "./chooseTakePhotoTimes.vue?vue&type=template&id=04ff75f2&scoped=true"
import script from "./chooseTakePhotoTimes.vue?vue&type=script&lang=js"
export * from "./chooseTakePhotoTimes.vue?vue&type=script&lang=js"
import style0 from "./chooseTakePhotoTimes.vue?vue&type=style&index=0&id=04ff75f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ff75f2",
  null
  
)

export default component.exports